/*eslint-disable*/
import{ Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Line, Bar } from "react-chartjs-2";
import {
  Button,
  ButtonGroup,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Label,
  FormGroup,
  Input,
  Table,
  Row,
  Col,
  UncontrolledTooltip
} from "reactstrap";

import Graph from "./graph.jsx"
import { MDBMask, MDBView, MDBContainer, MDBRow, MDBCol } from "mdbreact";
import React from "react";


class LargeWidget extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            graphToggle: !!this.props.varText,
            modalLarge: false,
            varText: this.props.varText,
        };
        this.toggleModalLarge = this.toggleModalLarge.bind(this);
        this.toggleGraph = this.toggleGraph.bind(this);
        this.handleVariableChange = this.handleVariableChange.bind(this);

    }

    toggleGraph(){
      this.setState({
          graphToggle: true,
          modalLarge: !this.state.modalLarge
      });
    }

    toggleModalLarge(){
        this.setState({
            modalLarge: !this.state.modalLarge
        });
    }

    handleVariableChange(event) {
      this.setState({
        varText: event.target.value
      });
      this.props.saveVariable(this.props.id,event.target.value);

    }

    show(flag){
      if (flag){
        return <Graph store={this.props.store} variable={this.state.varText}/>
      }else{
        return(
          <>
          <MDBView hover overlay>
          <div onClick={this.toggleModalLarge} >
            <Card className="card-chart" style={{cursor: "pointer"}}>
            <MDBMask overlay="green-slight"> </MDBMask>
              <CardHeader>
                <CardTitle tag="h3">
                  <h3><i className="tim-icons icon-simple-add text-AgriBoostGreen" />{" "}
                  Add New Graph</h3>
                </CardTitle>
              </CardHeader>
              <CardBody>
                <div className="chart-area" style={{textAlign:"center", fontSize: "10em"}}>
                  +
                </div>
              </CardBody>
            </Card>
          </div>
          </MDBView>
          <Modal isOpen={this.state.modalLarge} toggle={this.toggleModalLarge} size="lg">
              <ModalHeader className="justify-content-center" toggle={this.toggleModalLarge}>
                  Configure Widget
              </ModalHeader>
              <ModalBody>
                <form onSubmit={this.handleSubmit}>
                  <div className="form-row">
                    <Col lg="2">
                      <Label for="exampleSelect1">Hub ID</Label>
                        <Input type="select" name="select" id="exampleSelect1">
                          <option value={""}>Select...</option>
                          <option>Demo Hub</option>
                        </Input>
                      </Col>
                      <Col lg="2">
                        <Label for="exampleSelect1">Node ID</Label>
                          <Input type="select" name="select" id="exampleSelect1">
                            <option value={""}>Select...</option>
                            <option>Demo Node</option>
                          </Input>
                      </Col>
                      <Col lg="8">
                        <Label for="exampleSelect1">Variable</Label>
                          <Input type="select" name="select" id="exampleSelect1" onChange={this.handleVariableChange}>
                            <option value={""}>Select...</option>
                            <option>AmbientHumidity</option>
                            <option>UV</option>
                            <option>AmbientTemp</option>
                            <option>BarometerMoisture</option>
                            <option>SoilTemp</option>
                            <option>SoilMoisture</option>
                            <option>BarometerTemp</option>
                            <option>WindSpeed</option>
                            <option>BarometerPressure</option>
                          </Input>
                      </Col>
                    </div>
                </form>
              </ModalBody>
              <ModalFooter>
                  <Button color="secondary" onClick={this.toggleModalLarge}>
                      Close
                  </Button>
                  <Button color="primary" onClick={this.toggleGraph}>
                      Generate Graph
                  </Button>
              </ModalFooter>
          </Modal>
          </>
        );
      }
    }

    render() {
        return (
            <>

            {this.show(this.state.graphToggle && this.state.varText? true : false)}

            </>
        );
    }
}

 export default LargeWidget
